import React from 'react';
import { MonthsList, YearList } from './EventsData';
import './event.css';
// import { useHistory } from 'react-router-dom';

const HeaderDropdown = () => {
  // const history = useHistory();
  const handleEvent = (year: any, month: any, key: any) => {
    // console.log('==== On EVENT Click ====');
    // console.log(year, month, key);
    // console.log('========================');
    window.location.assign(`/event/${key}`);
  };

  return (
    <>
      <div className='event-list nav-item dropdown'>
        <a
          className=' dropdown-toggle'
          href='javascript:void(0)'
          id='navbarDropdownMenuLink'
          data-toggle='dropdown'
          aria-haspopup='true'
          aria-expanded='false'
        >
          Rise with Ethics
        </a>
        <ul
          className='dropdown-menu yearlist'
          aria-labelledby='navbarDropdownMenuLink'
        >
          {YearList?.map((year: any) => {
            return (
              <li className='dropdown-submenu year'>
                <a
                  className={`dropdown-item ${
                    !!MonthsList[year]?.length ? 'dropdown-toggle' : ''
                  }`}
                  href='#'
                >
                  {year}
                </a>
                {!!MonthsList[year]?.length && (
                  <ul className='dropdown-menu monthlist'>
                    {MonthsList[year].map((month: any) => {
                      return (
                        <li className='dropdown-submenu month'>
                          <a
                            // className={`dropdown-item ${
                            //   !!month.editionList?.length
                            //     ? 'dropdown-toggle'
                            //     : ''
                            // }`}
                            className={`dropdown-item`}
                            // href='#'
                            onClick={(e: any) =>
                              handleEvent(year, month?.month, month?.key)
                            }
                          >
                            {month?.month}
                          </a>
                          {/* {!!month.editionList?.length && (
                            <ul className='dropdown-menu eventlist'>
                              {month.editionList.map((edition: any) => {
                                return (
                                  <li>
                                    <a
                                      // href='#'
                                      className='dropdown-item'
                                      onClick={(e: any) =>
                                        handleEvent(year, month?.month, edition)
                                      }
                                    >
                                      {edition?.label}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          )} */}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default HeaderDropdown;
